import ApplicationStatusUpdate from 'BOSTools/components/ApplicationStatusUpdate';
import CaseAgentNumberUpdate from 'BOSTools/components/CaseAgentNumberUpdate';
import CaseNameUpdate from 'BOSTools/components/CaseNameUpdate';
import SicCodeUpdate from 'BOSTools/components/SicCodeUpdate';
import WrittenToL70Update from 'BOSTools/components/WrittenToL70Update';

export type Tool = {
  name: string;
  component: () => JSX.Element;
};

export const Tools: Tool[] = [
  {
    name: 'Application Status Update',
    component: ApplicationStatusUpdate,
  },
  {
    name: 'SA and AOR number Update',
    component: CaseAgentNumberUpdate,
  },
  {
    name: 'SIC Code Update',
    component: SicCodeUpdate,
  },
  {
    name: 'Case Name Update',
    component: CaseNameUpdate,
  },
  {
    name: 'Written To L70 Flag Update',
    component: WrittenToL70Update,
  },
];
